import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { Alert, Intent } from '@blueprintjs/core';
import Pagination from 'components/Pagination';
import Footer from 'components/Footer';
import Toast from 'helpers/toaster';
import * as DataList from 'components/DataList';

// Layout shared by the list and its loading skeleton (pages/question_groups/index.js).
export const QUESTION_GROUP_COLUMNS = [
  { area: 'name', label: 'Name', width: 'minmax(180px, 1fr)', bone: 'single' },
  { area: 'question', label: 'Question', width: 'minmax(240px, 2.5fr)', bone: 'single', icon: 'help' },
  { area: 'actions', label: '', width: '72px', bone: 'none' },
];

export const QUESTION_GROUP_CARDS = {
  columns: 'minmax(0, 1fr) auto',
  areas: ['name actions', 'question question'],
};

export const QUESTION_GROUP_MIN_TABLE_WIDTH = 600;

@inject('store', 'clientStore', 'questionGroupStore', 'viewStore') @observer
class QuestionGroupsTable extends Component {
  @observable isOpenAddEquipmentDialog = false;
  @observable isDeleteDialogVisible = false;
  @observable group;

  onPaginationChange(newPage) {
    let {
      viewStore: {
        questionGroupSearch
      }
    } = this.props;
    this.props.viewStore.questionGroupSearch = {
      ...questionGroupSearch,
      page: newPage
    };
    this.props.viewStore.questionGroups();
  }

  handleDeleteCancel() {
    this.isDeleteDialogVisible = false;
  }

  handleDeleteConfirm() {
    this.isDeleteDialogVisible = false;
    this.props.questionGroupStore.deleteQuestion(this.group)
      .then(this.onSuccessfulDeleteQuestion.bind(this))
      .catch(this.onFailDeleteQuestion.bind(this))
  }

  onSuccessfulDeleteQuestion(response) {
    Toast.show({ icon: 'thumbs-up', message: 'Question group deleted successfully!', intent: Intent.SUCCESS })
    this.group = null;
    this.isDeleteDialogVisible = false;
  }

  onFailDeleteQuestion(error) {
    this.isDeleteDialogVisible = false;
    Toast.show({ icon: 'warning-sign', message: 'Unable to delete question group!', intent: Intent.DANGER })
  }

  handleServiceTypeClick(event, group) {
    switch (event.label) {
      case 'Edit':
        this.group = group;
        this.props.viewStore.questionGroupShow({uuid: group.attributes.id})
        break;
      case 'Delete':
        this.isDeleteDialogVisible = true;
        this.group = group;
        break;
      default:
    }
  }

  // Empty list's "Clear search": back to all question groups, page 1.
  clearSearch() {
    const { viewStore } = this.props;
    viewStore.questionGroupSearch = { ...viewStore.questionGroupSearch, term: '*', page: 1 };
    viewStore.bumpListFilters();
    viewStore.questionGroups();
  }

  render() {
    let {
      viewStore,
      questionGroupStore: {
        groups: {
          objects,
          meta
        }
      }
    } = this.props;
    const { questionGroupSearch } = viewStore;
    const term = questionGroupSearch.term && questionGroupSearch.term !== '*' ? questionGroupSearch.term : '';

    if(objects.length === 0) {
      return (
        <DataList.Empty
          noun="question groups"
          term={term}
          onClearFilters={this.clearSearch.bind(this)}
          extraAction={!term && { label: 'Add question group', icon: 'plus', onClick: () => viewStore.questionGroupAdd(), primary: true }}
        />
      );
    }
    return (
      <React.Fragment>
        <Footer>
          <div className="bp3-navbar-group bp3-align-left">
            <Pagination
              value={meta.page}
              total={meta.total_pages}
              onChange={this.onPaginationChange.bind(this)}
            />
          </div>
        </Footer>
        <DataList.List
          columns={QUESTION_GROUP_COLUMNS}
          cards={QUESTION_GROUP_CARDS}
          minTableWidth={QUESTION_GROUP_MIN_TABLE_WIDTH}
          total={meta.total_records || objects.length}
          noun="question groups"
          note={DataList.sortNote(questionGroupSearch.order)}
        >
          {objects.map((groups) => {
            const attributes = groups.attributes;
            return (
              <DataList.Row key={groups.id}>
                <DataList.Cell area="name">
                  <DataList.Lines
                    title={attributes.name}
                    primary={
                      <DataList.RowLink
                        href={`/dashboard/question-group/${attributes.id}/show`}
                        label={`Question group ${attributes.name}`}
                      >
                        {attributes.name}
                      </DataList.RowLink>
                    }
                  />
                </DataList.Cell>
                <DataList.Cell area="question">
                  {attributes.question ? (
                    <DataList.Lines primary={attributes.question} strong={false} />
                  ) : (
                    <DataList.Muted>No question</DataList.Muted>
                  )}
                </DataList.Cell>
                <DataList.Cell area="actions">
                  <DataList.Actions
                    items={[
                      { icon: 'edit', label: 'Edit question group', onClick: () => viewStore.questionGroupShow({ uuid: attributes.id }) },
                      { icon: 'trash', label: 'Delete question group', intent: 'danger', onClick: () => this.handleServiceTypeClick({ label: 'Delete' }, groups) },
                    ]}
                  />
                </DataList.Cell>
              </DataList.Row>
            );
          })}
        </DataList.List>
        <Alert
          cancelButtonText="Cancel"
          confirmButtonText="Delete"
          icon="trash"
          intent={Intent.DANGER}
          isOpen={this.isDeleteDialogVisible}
          onCancel={this.handleDeleteCancel.bind(this)}
          onConfirm={this.handleDeleteConfirm.bind(this)}
        >
          <p>Warnning! Deleting this question group will not be recoverable.</p>
          <p>Are you sure you want to do this?</p>
        </Alert>
        <Footer>
          <div className="bp3-navbar-group bp3-align-left">
            <Pagination
              value={meta.page}
              total={meta.total_pages}
              onChange={this.onPaginationChange.bind(this)}
            />
          </div>
        </Footer>
      </React.Fragment>
    )
  }

}

export default QuestionGroupsTable;